import i18n from 'src/features/i18n';

function secondsToHmsHumanize(seconds) {
  const interval = parseInt(seconds, 10);

  const h = Math.abs(Math.floor(interval / 3600));
  const m = Math.abs(Math.floor((interval / 60) % 60));
  const s = Math.abs(Math.floor(interval % 3600 % 60));

  let hour = '';

  if (h > 0) {
    hour = `${h} ${i18n.t('T_HOUR')} `;
  }

  return `${hour}${m} ${i18n.t('T_MIN')} ${s} ${i18n.t('T_SEC')}`;
}

export default secondsToHmsHumanize;
